import React from 'react'
import { ReactComponent } from './edit.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface EditProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', EditProps>

export const EditIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#57454A' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
